module.exports = __webpack_public_path__ + "static/img/ES.fe8e67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/ES.png
// module id = nAQw
// module chunks = 1